module.exports = __webpack_public_path__ + "img/bold.045d7e19.svg";